const UINT32_MAX_PLUS_ONE = 4294967296

const randomBuffer = new Uint32Array(1)

/** Uniform [0, 1) float from cryptographically secure randomness (replaces Math.random for Sonar S2245). */
export const secureRandomFloat = (): number => {
  crypto.getRandomValues(randomBuffer)
  return randomBuffer[0] / UINT32_MAX_PLUS_ONE
}
